import { AHText, AHTextFonts, Box } from "arkh";

export function TodoListItemFooterItem(props: {
  children: React.ReactNode;
  isFirst?: boolean;
}) {
  return (
    <Box
      borderColor="negative"
      style={{
        flexDirection: "row",
        alignItems: "center",
      }}
      spaceRight="medium"
      spaceBottom="xsmall"
    >
      {props.children}
    </Box>
  );
}

export function TodoListItemFooterLabel(props: {
  children: React.ReactNode;
  maxWidth?: number;
}) {
  return (
    <AHText
      size="body"
      font={AHTextFonts.MEDIUM}
      color="text-secondary"
      numberOfLines={1}
      ellipsizeMode="tail"
      style={{ flexShrink: 1, maxWidth: props.maxWidth }}
    >
      {props.children}
    </AHText>
  );
}
